import SubmittedMessage from './SubmittedMessage';

export default SubmittedMessage;
